<template>
  <CRow>
    <CCol md="12" style="font-size: 14px; margin-bottom: 80px;">

      <CDataTable :hover="hover" :striped="striped" :border="border" :small="small" :fixed="fixed" :items="items"
        :fields="fields" :items-per-page="small ? 30 : 50" :dark="dark" pagination
        :noItemsView="{ noResults: 'No se encontraron envíos', noItems: 'Sin historial' }">

        <!-- HEADER TOTAL MSJ -->
        <template #total-header>
          <div class="text-center">
            <CIcon name="cil-speech" class="wa-icon wa-icon--total mr-1" />
            Total Msj
          </div>
        </template>

        <!-- HEADER SOLICITADOS -->
        <template #total_request-header>
          <div class="text-center">
            <CIcon name="cil-clock" class="wa-icon wa-icon--pending mr-1" />
            No enviados
          </div>
        </template>

        <!-- HEADER ENVIADOS -->
        <template #total_send-header>
          <div class="text-center">
            <CIcon name="cil-check" class="wa-icon wa-icon--sent mr-1" />
            Enviados
          </div>
        </template>

        <!-- HEADER ENTREGADOS -->
        <template #total_delivered-header>
          <div class="text-center">
            <span class="wa-checks wa-checks--delivered mr-1">
              <CIcon name="cil-check" class="wa-icon" />
              <CIcon name="cil-check" class="wa-icon wa-icon--second" />
            </span>
            Entregados
          </div>
        </template>

        <!-- HEADER LEÍDOS -->
        <template #total_read-header>
          <div class="text-center">
            <span class="wa-checks wa-checks--read mr-1">
              <CIcon name="cil-check" class="wa-icon" />
              <CIcon name="cil-check" class="wa-icon wa-icon--second" />
            </span>
            Leídos
          </div>
        </template>

        <!-- HEADER ERROR -->
        <template #total_failed-header>
          <div class="text-center">
            <CIcon name="cil-warning" class="wa-icon wa-icon--failed mr-1" />
            Error
          </div>
        </template>

        <!-- POSICIÓN -->
        <template #position="{ index }">
          <td class="text-center">
            {{ index + 1 }}
          </td>
        </template>

        <template #code="{ item }">
          <td class="text-center">
            {{ item.code.substr(-8) }}
          </td>
        </template>

        <!-- FECHA -->
        <template #date="{ item }">
          <td class="text-center">
            {{ item.date | date }}
          </td>
        </template>

        <!-- TIPO -->
        <template #type="{ item }">
          <td class="text-center">
            {{ getTypeLabel(item.type) }}
          </td>
        </template>

        <!-- TOTAL -->
        <template #total="{ item }">
          <td class="text-center">
            {{ item.total }}
          </td>
        </template>

        <!-- TOTAL_REQUEST -->
        <template #total_request="{ item }">
          <td class="text-center wa-cell">
            {{ item.total_request }} / {{ item.total }}
          </td>
        </template>

        <!-- TOTAL_SEND -->
        <template #total_send="{ item }">
          <td class="text-center wa-cell">
            {{ item.total_send }} / {{ item.total }}
          </td>
        </template>

        <!-- TOTAL_DELIVERED -->
        <template #total_delivered="{ item }">
          <td class="text-center wa-cell">
            {{ item.total_delivered }} / {{ item.total }}
          </td>
        </template>

        <!-- TOTAL_READ -->
        <template #total_read="{ item }">
          <td class="text-center wa-cell">
            {{ item.total_read }} / {{ item.total }}
          </td>
        </template>

        <!-- TOTAL_FAILED -->
        <template #total_failed="{ item }">
          <td class="text-center wa-cell">
            {{ item.total_failed }} / {{ item.total }}
          </td>
        </template>

        <template #status="{ item }">
          <td class="text-center">
            <span :class="['wa-badge', 'wa-badge--' + item.status]">
              {{ getBatchStatusLabel(item.status) }}
            </span>
          </td>
        </template>



        <!-- ACCIONES -->
        <template #actions="{ item }">
          <td class="text-center">
            <CButton color="info" size="sm" @click="$emit('show-detail', item)">
              Detalle
            </CButton>
            <CButton color="success" size="sm" class="ml-1" @click="$emit('download-excel-detail', item.id)">
              Excel
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: 'HistoryTable',

  props: {
    items: { type: Array, required: true },
    event: { type: Object, required: true },

    hover: { type: Boolean, default: true },
    striped: { type: Boolean, default: true },
    border: { type: Boolean, default: true },
    small: { type: Boolean, default: true },
    fixed: { type: Boolean, default: true },
    dark: { type: Boolean, default: false }
  },

  computed: {
    fields() {
      return [
        { key: 'position', label: 'N°', _style: 'width: 50px;' },
        { key: 'code', label: 'Código', _style: 'width: 50px;' },
        { key: 'date', label: 'Fecha Envío', _style: 'width: 140px;' },
        { key: 'type', label: 'Tipo Mensaje', _style: 'width: 150px;' },
        { key: 'status', label: 'Estado', _style: 'width: 120px;' },

        { key: 'total', label: 'Total Msj', _style: 'width: 100px;' },
        { key: 'total_request', label: '', _style: 'width: 100px;' },
        { key: 'total_send', label: '', _style: 'width: 100px;' },
        { key: 'total_delivered', label: '', _style: 'width: 110px;' },
        { key: 'total_read', label: '', _style: 'width: 90px;' },
        { key: 'total_failed', label: '', _style: 'width: 80px;' },

        { key: 'actions', label: 'Acciones', _style: 'width: 130px;' }
      ]
    }

  },

  methods: {
    getTypeLabel(type) {
      switch (type) {
        case 'save_the_date': return 'Save The Date'
        case 'preinvitation': return 'Preinvitacion'
        case 'event_reminder': return 'Recordatorio de Evento'
        case 'reminder': return 'Recordatorio'
        case 'message': return 'Mensaje'
        case 'table': return 'Mesas'
        case 'tickets': return 'Tickets'
        case 'invitation': return 'Invitación'
        default: return type
      }
    },
    getBatchStatusLabel(status) {
      switch (status) {
        case 'pending': return 'Pendiente'
        case 'in_progress': return 'En proceso'
        case 'done': return 'Finalizado'
        default: return status
      }
    },
  }
}
</script>
<style scoped>
/* celdas */
.wa-cell {
  white-space: nowrap;
}

/* tamaño base iconos */
.wa-icon {
  font-size: 14px;
  vertical-align: -2px;
}

/* colores "tipo WhatsApp" (no dependen del tema) */
.wa-icon--pending {
  color: #6c757d;
}

/* gris */
.wa-icon--sent {
  color: #6c757d;
}

/* gris */
.wa-icon--failed {
  color: #dc3545;
}

/* rojo */

/* doble check: alineación/solape ligero */
.wa-checks {
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.wa-icon--second {
  margin-left: -6px;
  /* solape tipo WhatsApp */
}

/* delivered: gris */
.wa-checks--delivered .wa-icon {
  color: #6c757d;
}

/* read: azul WhatsApp */
.wa-checks--read .wa-icon {
  color: #34B7F1;
}

/* status */
/* ===== ICONO TOTAL ===== */
.wa-icon--total {
  color: #546e7a;
}

/* ===== BADGE BASE ===== */
.wa-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  display: inline-block;
}

/* ===== ESTADOS ===== */

.wa-badge--pending {
  background-color: #f0ad4e;
  /* naranja */
}

.wa-badge--in_progress {
  background-color: #5bc0de;
  /* azul claro */
}

.wa-badge--done {
  background-color: #5cb85c;
  /* verde */
}

/* fallback */
.wa-badge--undefined,
.wa-badge--null {
  background-color: #6c757d;
}
</style>
